/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * * Utility functions around everything related to JavaScript URLs
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

/**
 * Checks whether the provided URI is encoded or not
 * https://stackoverflow.com/a/38265168
 *
 * @param {string} uri The URI to check
 * @return {boolean} Whether the URI is encoded or not
 */
function isEncoded(uri) {
  return uri !== decodeURIComponent(uri || '');
}


/**
 * Recursively checks if the provided URI is encoded and tries to decode it.
 * https://stackoverflow.com/a/38265168
 *
 * @param {string} uri The URI to deocde
 * @return {string} The decoded URI
 */
function fullyDecodeURI(uri){
  while (isEncoded(uri)){
    uri = decodeURIComponent(uri);
  }

  return uri;
}


// -----------------------------------------------------------------------------
// EXPORTS
// -----------------------------------------------------------------------------

export {
  fullyDecodeURI,
  isEncoded
};
